import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'

// container panel

export const ActivityMonitorContainer = styled.div<{ height?: string }>`
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${props => props.height || '100%'};
  background-color: ${constants.CORE_PRIMARY};
  color: ${constants.CORE_PRIMARY_6};
  box-shadow: 0 6px 60px 0 rgba(0, 0, 0, 0.13);
`

export const ActivityMonitorTitle = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 30px;
  padding: 5px 10px;
  font-family: NEXWeb;
  font-weight: ${constants.FontWeight.Medium};
  font-size: 14px;
  color: ${constants.CORE_PRIMARY_3};
  background-color: ${constants.CORE_PRIMARY_7};
  justify-content: space-between;
`

export const ActivityMonitorCloseButton = styled.div`
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;

  svg {
    height: 12px;
    width: 12px;
  }
`

export const ActivityListContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px;
  overflow-y: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  & > div:not(:last-child) {
    margin-bottom: 10px;
  }
`

export const ActivityListEmptyPlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-bottom: 20px;
  font-size: 16px;
`

export const AdminClearingAlert = styled.div`
  display: flex;
  align-items: center;
  padding: 6px;
  border-radius: 3px;
  background-color: ${constants.ACCENT_BAD_1};
  color: ${constants.CORE_PRIMARY};

  svg {
    width: 18px;
    height: 18px;
    margin-right: 5px;
  }
`

// toolbar

export const ActivityMonitorToolbarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  flex: 0 0 46px;
  padding: 10px;
  background-color: ${constants.CORE_PRIMARY_1};
`
